/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PersonaleRapportinoUpdateDTO } from './PersonaleRapportinoUpdateDTO';
import {
    PersonaleRapportinoUpdateDTOFromJSON,
    PersonaleRapportinoUpdateDTOFromJSONTyped,
    PersonaleRapportinoUpdateDTOToJSON,
    PersonaleRapportinoUpdateDTOToJSONTyped,
} from './PersonaleRapportinoUpdateDTO';

/**
 * 
 * @export
 * @interface RapportiniUpdateDTO
 */
export interface RapportiniUpdateDTO {
    /**
     * 
     * @type {string}
     * @memberof RapportiniUpdateDTO
     */
    descrizioneAttivita?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RapportiniUpdateDTO
     */
    ubicazioneTest?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RapportiniUpdateDTO
     */
    descrizioneLavori?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RapportiniUpdateDTO
     */
    strumentiMisura?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RapportiniUpdateDTO
     */
    isRelazioneProva?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RapportiniUpdateDTO
     */
    isSchedaTecnica?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RapportiniUpdateDTO
     */
    riferimentoOrdine?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RapportiniUpdateDTO
     */
    luogo?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RapportiniUpdateDTO
     */
    personaRiferimento?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RapportiniUpdateDTO
     */
    isTrimestrale?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RapportiniUpdateDTO
     */
    isSemestrale?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RapportiniUpdateDTO
     */
    isAnnuale?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RapportiniUpdateDTO
     */
    isManutenzioneStraordinaria?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RapportiniUpdateDTO
     */
    isControlliNonDistruttivi?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof RapportiniUpdateDTO
     */
    dataRiferimentoOrdine?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof RapportiniUpdateDTO
     */
    riferimentoDDT?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof RapportiniUpdateDTO
     */
    dataRiferimentoDDT?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof RapportiniUpdateDTO
     */
    attrezzatureSpeciali?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RapportiniUpdateDTO
     */
    isCheckList?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RapportiniUpdateDTO
     */
    isReportAnomalie?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RapportiniUpdateDTO
     */
    isReportIntervento?: boolean;
    /**
     * 
     * @type {Array<PersonaleRapportinoUpdateDTO>}
     * @memberof RapportiniUpdateDTO
     */
    personaleRapportino?: Array<PersonaleRapportinoUpdateDTO> | null;
}

/**
 * Check if a given object implements the RapportiniUpdateDTO interface.
 */
export function instanceOfRapportiniUpdateDTO(value: object): value is RapportiniUpdateDTO {
    return true;
}

export function RapportiniUpdateDTOFromJSON(json: any): RapportiniUpdateDTO {
    return RapportiniUpdateDTOFromJSONTyped(json, false);
}

export function RapportiniUpdateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): RapportiniUpdateDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'descrizioneAttivita': json['descrizioneAttivita'] == null ? undefined : json['descrizioneAttivita'],
        'ubicazioneTest': json['ubicazioneTest'] == null ? undefined : json['ubicazioneTest'],
        'descrizioneLavori': json['descrizioneLavori'] == null ? undefined : json['descrizioneLavori'],
        'strumentiMisura': json['strumentiMisura'] == null ? undefined : json['strumentiMisura'],
        'isRelazioneProva': json['isRelazioneProva'] == null ? undefined : json['isRelazioneProva'],
        'isSchedaTecnica': json['isSchedaTecnica'] == null ? undefined : json['isSchedaTecnica'],
        'riferimentoOrdine': json['riferimentoOrdine'] == null ? undefined : json['riferimentoOrdine'],
        'luogo': json['luogo'] == null ? undefined : json['luogo'],
        'personaRiferimento': json['personaRiferimento'] == null ? undefined : json['personaRiferimento'],
        'isTrimestrale': json['isTrimestrale'] == null ? undefined : json['isTrimestrale'],
        'isSemestrale': json['isSemestrale'] == null ? undefined : json['isSemestrale'],
        'isAnnuale': json['isAnnuale'] == null ? undefined : json['isAnnuale'],
        'isManutenzioneStraordinaria': json['isManutenzioneStraordinaria'] == null ? undefined : json['isManutenzioneStraordinaria'],
        'isControlliNonDistruttivi': json['isControlliNonDistruttivi'] == null ? undefined : json['isControlliNonDistruttivi'],
        'dataRiferimentoOrdine': json['dataRiferimentoOrdine'] == null ? undefined : (new Date(json['dataRiferimentoOrdine'])),
        'riferimentoDDT': json['riferimentoDDT'] == null ? undefined : json['riferimentoDDT'],
        'dataRiferimentoDDT': json['dataRiferimentoDDT'] == null ? undefined : (new Date(json['dataRiferimentoDDT'])),
        'attrezzatureSpeciali': json['attrezzatureSpeciali'] == null ? undefined : json['attrezzatureSpeciali'],
        'isCheckList': json['isCheckList'] == null ? undefined : json['isCheckList'],
        'isReportAnomalie': json['isReportAnomalie'] == null ? undefined : json['isReportAnomalie'],
        'isReportIntervento': json['isReportIntervento'] == null ? undefined : json['isReportIntervento'],
        'personaleRapportino': json['personaleRapportino'] == null ? undefined : ((json['personaleRapportino'] as Array<any>).map(PersonaleRapportinoUpdateDTOFromJSON)),
    };
}

export function RapportiniUpdateDTOToJSON(json: any): RapportiniUpdateDTO {
    return RapportiniUpdateDTOToJSONTyped(json, false);
}

export function RapportiniUpdateDTOToJSONTyped(value?: RapportiniUpdateDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'descrizioneAttivita': value['descrizioneAttivita'],
        'ubicazioneTest': value['ubicazioneTest'],
        'descrizioneLavori': value['descrizioneLavori'],
        'strumentiMisura': value['strumentiMisura'],
        'isRelazioneProva': value['isRelazioneProva'],
        'isSchedaTecnica': value['isSchedaTecnica'],
        'riferimentoOrdine': value['riferimentoOrdine'],
        'luogo': value['luogo'],
        'personaRiferimento': value['personaRiferimento'],
        'isTrimestrale': value['isTrimestrale'],
        'isSemestrale': value['isSemestrale'],
        'isAnnuale': value['isAnnuale'],
        'isManutenzioneStraordinaria': value['isManutenzioneStraordinaria'],
        'isControlliNonDistruttivi': value['isControlliNonDistruttivi'],
        'dataRiferimentoOrdine': value['dataRiferimentoOrdine'] == null ? undefined : ((value['dataRiferimentoOrdine'] as any).toISOString()),
        'riferimentoDDT': value['riferimentoDDT'],
        'dataRiferimentoDDT': value['dataRiferimentoDDT'] == null ? undefined : ((value['dataRiferimentoDDT'] as any).toISOString()),
        'attrezzatureSpeciali': value['attrezzatureSpeciali'],
        'isCheckList': value['isCheckList'],
        'isReportAnomalie': value['isReportAnomalie'],
        'isReportIntervento': value['isReportIntervento'],
        'personaleRapportino': value['personaleRapportino'] == null ? undefined : ((value['personaleRapportino'] as Array<any>).map(PersonaleRapportinoUpdateDTOToJSON)),
    };
}

